<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.superAmbassador.read")}}</span>
    <div v-if="dataLoaded" class="sheet-container">
      <AveineSuperAmbassadorSheet :APIbaseURL="APIbaseURL" :superAmbassador="superAmbassador" :adminMode="true" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineSuperAmbassadorSheet } from 'aveine-super-ambassador'
import { SuperAmbassador } from 'aveine-toolbox'
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      superAmbassador: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Read',
  components: {
    AveineSuperAmbassadorSheet
  },
  async created() {
    try {
      await SuperAmbassador.api().get(`super-ambassadors/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
          params: {
            include:
            'company.company-contact,company.address.spatial-information',
          }
        }
      );
      this.superAmbassador = await SuperAmbassador.query().whereId(this.$route.params.id).withAllRecursive().first();
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
